// modal.service.ts
import { ComponentType, Overlay, OverlayConfig, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  private overlayRef: OverlayRef | null = null;

  constructor(private overlay: Overlay) {}

  open<T>(component: ComponentType<T>, data?: any): OverlayRef {
    const config = new OverlayConfig({
      hasBackdrop: true,
      panelClass: 'modal-panel', // Add custom CSS class for styling if needed
      backdropClass: 'modal-backdrop',
      positionStrategy: this.overlay.position().global().centerHorizontally().centerVertically()
    });

    this.overlayRef = this.overlay.create(config);
    const modalPortal = new ComponentPortal(component);
    const componentRef: any = this.overlayRef.attach(modalPortal);

    // Pass data to the modal component
    if (data) {
      Object.assign(componentRef.instance, data);
    }

    this.overlayRef.backdropClick().subscribe(() => this.close());
    return this.overlayRef;
  }

  close(): void {
    if (this.overlayRef) {
      this.overlayRef.dispose();
      this.overlayRef = null;
    }
  }
}
